import {UntypedFormControl, Validators} from "@angular/forms";
import {Patterns} from "../shared/enums/patterns";

/**
 * Common base class for create and update org components.
 */
export abstract class PositionAliasBase {
    
    readonly ALIAS_MIN_LENGTH = 1;
    readonly ALIAS_ID_MAX_LENGTH = 50;

    readonly POSITION_ID = 'positionId';
    readonly ALIAS = 'alias';

    positionId = new UntypedFormControl('', [Validators.min(1), Validators.max(99999),
        Validators.pattern(Patterns.NUMERIC)]);
    alias = new UntypedFormControl('', [
        Validators.minLength(this.ALIAS_MIN_LENGTH), Validators.maxLength(this.ALIAS_ID_MAX_LENGTH),
        Validators.pattern(Patterns.ALPHANUMERICPLUSSPECIAL)
    ]); 

    fieldcheck: boolean = false;
    loading: boolean = false;
    count: number = 1;

    constructor() {}

    markFormControlsAsTouched() {
        this.positionId.markAsTouched();
        this.alias.markAsTouched();
    }

    getErrorMessage(formControl) {
        if (formControl === this.POSITION_ID) {
            return this.positionId.hasError('required') ? 'You must enter a value' : 'Enter a valid Position Id';
        } else if (formControl === this.ALIAS) {
            return this.alias.hasError('required') ? 'You must enter a value' : 'Enter a valid alias (1-50 alphanumeric characters with special characters like !, @, #, $, %, &, *, _, -, +, etc.)';
        }
    }

    change(event) {
        if(event) {
            if (event.srcElement.value !== '') {
                this.count = this.count + 1;
            } else if (event.srcElement.value === '') {
                this.count = this.count - 1;
            }
        }
        if (this.count <= 1 || !this.fieldcheck) {
            this.fieldcheck = true;
        }
    }

}
